module.exports = __webpack_public_path__ + "static/media/earthi.fa47fdfc.svg";